import {PAGES} from "../../../../core/consts";
import {BaseConfig} from "../../../../infrastructure/config/base-config";
import {GameCenterIndexPageRouteConfig} from "./models/game-center.index-page.route.config";

export class GameCenterIndexPageConfig extends BaseConfig {
  static injectables = [GameCenterIndexPageRouteConfig];

  constructor(route: GameCenterIndexPageRouteConfig) {
      super(PAGES.GAME_CENTER.index, route);
  }
}
